import { Injectable } from "@angular/core";
import { ApiService } from "../api.service";
import { IContentPublishOptions } from "../../interfaces/content-publish-options.interface";

@Injectable()
export class CampaignService {
  private apiPrefix = '/admin/campaigns';

  constructor(
    private api: ApiService
  ) {
  }

  create(data) {
    return this.api.post(`${this.apiPrefix}`, data);
  }

  update(id: number, data) {
    return this.api.patch(`${this.apiPrefix}/${id}`, data);
  }

  getList(qs = '') {
    return this.api.get(`${this.apiPrefix}${qs}`);
  }

  remove(id: number) {
    return this.api.delete(`${this.apiPrefix}/${id}`);
  }

  publish(id: number, opts: IContentPublishOptions) {
    return this.api.patch(`${this.apiPrefix}/${id}/publish`, opts);
  }

  unpublish(id: number) {
    return this.api.delete(`${this.apiPrefix}/${id}/publish`);
  }

  createImage(id: number, data) {
    return this.api.post(`${this.apiPrefix}/${id}/image`, data);
  }

  saveImage(id: number, requestId: string) {
    return this.api.patch(`${this.apiPrefix}/${id}/image/${requestId}`, {});
  }
}
